var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: ['ugc-top-bar row', {
      hide: _vm.hide
    }]
  }, [_c('div', {
    staticClass: "small-1 columns ugc-top-bar-close"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isGCC,
      expression: "!isGCC"
    }],
    staticClass: "ugc-modal-button ugc-top-bar-close-icon",
    attrs: {
      "disabled": !_vm.hideFinishButton && _vm.isFinishButtonDisabled,
      "type": "button"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), !_vm.hide ? _c('ugc-steps-view', {
    attrs: {
      "customizerHeaderUGCLargeButton": _vm.customizerHeaderUGCLargeButton
    }
  }) : _vm._e(), _c('button', {
    class: ['columns ugc-top-bar-next ugc-modal-button', _vm.customizerHeaderUGCLargeButton ? 'small-3' : 'small-2', {
      hide: _vm.hideUGCNextButton
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.toggleNextButton
    },
    on: {
      "click": _vm.checkPlacement
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translations.ugcTopBarNext) + " >\n  ")]), _c('button', {
    class: ['small-2 columns ugc-top-bar-finish primary button', {
      hide: _vm.hideFinishButton
    }, {
      disabled: _vm.isFinishButtonDisabled
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translations.ugcTopBarFinish) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }